import './App.css';
import { Routes, Route } from 'react-router-dom';

import LandingPage from './components/LandingPage/LandingPage';
import AboutPage from './components/AboutPage/AboutPage';
import ServicesPage from './components/Services/ServicesPage';
import PropertyPage from './components/AboutPage/PropertyPage/PropertyPage';
import ContactUs from './components/ContactUs/ContactUs';
import AdminLogin from './components/Admin/AdminLogin';
import StateDetails from './components/LandingPage/StateDetails';
import ForgotPassword from './components/Admin/ForgotPassword';
import ResetPassword from './components/Admin/ResetPassword';
import AdminLayout from './components/AdminLayout/AdminLayout';
import { AdminProvider } from './components/AdminLayout/AdminProvider';
import MainLandingPage from './components/Landing/MainLandingPage';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import ChooseRole from './components/Landing/ChooseRole';
import Home from './components/User/pages/Home';
import Login from './components/Landing/Login';
import Header from './components/User/Header';
import CategoriesWeb from './components/User/CategoriesWeb';
import PropertyDetails from './components/User/pages/PropertyDetails';
import Saved from './components/User/Saved';
import Profile from './components/User/pages/Profile';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute.jsx'
import ProjectHead from './components/User/ProjectHead/ProjectHead.jsx';
import HeadProfile from './components/User/ProjectHead/Profile.js';
import Properties from './components/User/ProjectHead/Properties.jsx';
import Agents from './components/User/ProjectHead/Agents.js';
import AgentScreen from './components/User/AgentScreen/AgentScreen.js';
import MyListings from './components/User/AgentScreen/Listings.js';
import ProductDetails from './components/User/AgentScreen/ProductDetails.js';
import LeadScreen from './components/User/AgentScreen/LeadScreen.js';
import AgentProfile from './components/User/AgentScreen/Profile.js';
import PropertyOwner from './components/User/PropertyOwner/PropertyOwner.js';
import MyProperties from './components/User/PropertyOwner/MyProperties.js';
import AddProperty from './components/User/PropertyOwner/AddProperty.js';
import PropertyOwnerProfile from './components/User/PropertyOwner/Profile.js';
import Bookings from './components/User/PropertyOwner/Bookings.js';
import Bookings_Investor from './components/User/pages/Bookings.js';
import GreetingPage from './components/User/AgentScreen/GreetingPage.js';
import AllLeads from './components/User/AgentScreen/AllLeads.js';
import UserDeleteManagement from './components/UserDeleteManagement/UserDeleteManagement.js';
import PropertiesInvestor from './components/User/pages/Properties.js'
import HighwaysProperties from './components/Landing/HighwaysProperties.js';
import Properties_agent from './components/User/AgentScreen/Properties';

function App() {
  return (
    <div className="App">
      <Routes>

        {/* PUBLIC ROUTES */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/property/:type" element={<PropertyPage />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/state/:stateName" element={<StateDetails />} />
 <Route path="/highways" element={<HighwaysProperties /> }/>

        {/* AUTH ROUTES */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        {/* <Route path="/homee" element={<Home />} />  */} 

 <Route path="/delete" element={<UserDeleteManagement />} />


        <Route path="/mainlandingpage" element={<MainLandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/choose-role" element={<ChooseRole />} />


        <Route path="/headProfile" element={<HeadProfile />} />
        {/* ADMIN PANEL */}


        <Route
          path="/admin-dashboard/*"
          element={
            <PrivateRoute>
              <AdminProvider>
                <AdminLayout />
              </AdminProvider>
            </PrivateRoute>
          }
        />

        <Route
          path="/homee"
          element={
            <ProtectedRoute allowedRoles={["investor"]}>
              <Home />
            </ProtectedRoute>
          }
        />

        <Route path="/properties/:id" element={<ProtectedRoute allowedRoles={["investor"]}> <PropertyDetails /> </ProtectedRoute>} />
        <Route path="/categories" element={<ProtectedRoute allowedRoles={["investor"]}><CategoriesWeb /></ProtectedRoute>} />

        <Route path="/bookings_Investor" element={<ProtectedRoute allowedRoles={["investor"]}> <Bookings_Investor /> </ProtectedRoute>} />
        <Route path="/saved" element={<ProtectedRoute allowedRoles={["investor"]}> <Saved />  </ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute allowedRoles={["investor"]}> <Profile /> </ProtectedRoute>} />
  <Route path="/properties" element={<ProtectedRoute allowedRoles={["investor"]}> <PropertiesInvestor /> </ProtectedRoute>} />

        {/* Project Head */}
        <Route
          path="/project_head"
          element={
            <ProtectedRoute allowedRoles={["projectHead"]}>
              <ProjectHead />
            </ProtectedRoute>
          }
        />
        <Route path="/properties" element={<ProtectedRoute allowedRoles={["projectHead"]}><Properties /></ProtectedRoute>} />
        <Route path="/agents" element={<ProtectedRoute allowedRoles={["projectHead"]}><Agents /></ProtectedRoute>} />


        {/* Agent */}
        <Route
          path="/agent_scren"
          element={
            <ProtectedRoute allowedRoles={["agent"]}>
              <AgentScreen />
            </ProtectedRoute>
          }
        />
        <Route path="/MyListings" element={<ProtectedRoute allowedRoles={["agent"]}>  <MyListings /> </ProtectedRoute>} />

        <Route path="/product/:id" element={<ProtectedRoute allowedRoles={["agent"]}>  <ProductDetails /> </ProtectedRoute>} />


        <Route path="/LeadScreen" element={<ProtectedRoute allowedRoles={["agent"]}>  <LeadScreen /> </ProtectedRoute>} />

        <Route path="/agentProfile" element={<ProtectedRoute allowedRoles={["agent"]}>  <AgentProfile /> </ProtectedRoute>} />

  <Route path="/greetings" element={<ProtectedRoute allowedRoles={["agent"]}>  <GreetingPage /> </ProtectedRoute>} />

  <Route path="/all-leads" element={<ProtectedRoute allowedRoles={["agent"]}>  <AllLeads /> </ProtectedRoute>} />
  <Route path="/properties_agent" element={<ProtectedRoute allowedRoles={["agent"]}> <Properties_agent /> </ProtectedRoute>} />






        {/* Owner */}
        <Route
          path="/propert_owner"
          element={
            <ProtectedRoute allowedRoles={["owner"]}>
              <PropertyOwner />
            </ProtectedRoute>
          }
        />
        <Route
          path="/propert_owner_profile"
          element={
            <ProtectedRoute allowedRoles={["owner"]}>
              <PropertyOwnerProfile />
            </ProtectedRoute>
          }
        />

        {/* <Route path="/owner/dashboard" element={<OwnerDashboard />} /> */}
        <Route path="/owner/properties" element={<ProtectedRoute allowedRoles={["owner"]}> <MyProperties />  </ProtectedRoute>} />
        <Route path="/owner/add-property" element={<ProtectedRoute allowedRoles={["owner"]}> <AddProperty />  </ProtectedRoute>} />

        <Route path="/bookings" element={<ProtectedRoute allowedRoles={["owner"]}><Bookings />     </ProtectedRoute>} />

      </Routes>
    </div>
  );
}

export default App;
